import axios from "axios";
import { config } from "../config";

export const api = axios.create({
  baseURL: config.apiUrl,
});

api.interceptors.request.use(
  async (conf) => {
    const [dirtyTokenId, dirtyTokenCSRF] = await Promise.all([
      localStorage.getItem(`@${config.appAgent}:token-id`),
      localStorage.getItem(`@${config.appAgent}:token-csrf`),
    ]);

    const tokenName = String(dirtyTokenId || "")
      .replace('"', "")
      .replace('"', "");
    const tokenValue = String(dirtyTokenCSRF || "")
      .replace('"', "")
      .replace('"', "");

    if (tokenName && tokenValue) {
      conf.headers["token-id"] = tokenName;
      conf.headers["token-csrf"] = tokenValue;
    }

    conf.headers["app-lang"] = "pt-br";

    return conf;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  async (response) => {
    if (response.headers["token-id"] || response?.data?.token?.id) {
      localStorage.setItem(
        `@${config.appAgent}:token-id`,
        String(response.headers["token-id"] || response?.data?.token?.id)
      );
    }
    if (response.headers["token-csrf"] || response?.data?.token?.csrf) {
      localStorage.setItem(
        `@${config.appAgent}:token-csrf`,
        String(response.headers["token-csrf"] || response?.data?.token?.csrf)
      );
    }

    return response;
  },
  async (error) => {
    console.log("error?.response?.data", error?.response?.data || error);
    // if (String(error?.response?.data?.errorCode || '').match('CSRFX')) {
    //   await Promise.all([
    //     AsyncStorage.removeItem(`@${config.appAgent}:customer`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:customer-profile`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:token-id`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:token-csrf`),
    //   ])
    // }
    return Promise.reject(error);
  }
);
